<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmtx1"><b>The Kingdom of Saudi Arabia and the Middle East Region</b></div>
<div class="fmtx1">SOURCE: Simmons &amp; Company International</div>
<div class="centerAligned"><img alt="003" class="imgepub" src="simm_9781118040522_oeb_003_r1.gif"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// simm_9781118040522_oeb_fm1_r1.vue?42fc4da0